import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { ClasseVitesse } from 'src/app/domain/Shared/classe-vitesse';
import { Prelevement } from 'src/app/domain/Shared/prelevement';
import { PrelevementVitesse } from 'src/app/domain/Shared/prelevement-vitesse';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SampleTakingModel } from 'src/app/models/new-substrat-model';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { IBGNService } from 'src/app/services/ibgn.service';
import { MPCEService } from 'src/app/services/mpce-service';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { PrelevementDialogComponent } from 'src/app/tools/ui/prelevement-dialog/prelevement-dialog.component';
import { PrelevementDialogModel } from 'src/app/tools/ui/prelevement-dialog/prelevement-dialog.model';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { SubstratAndVitesseDialogComponent } from 'src/app/tools/ui/substrat-and-vitesse-dialog/substrat-and-vitesse-dialog.component';

@Component({
    selector: 'app-plan-prelevement',
    templateUrl: './plan-prelevement.component.html',
    styleUrls: ['./plan-prelevement.component.scss']
})
export class PlanPrelevementComponent implements OnInit {

    SelectedSubstrat: SampleTakingModel;
    SampleTakingList: SampleTakingModel[] = [];
    PresenceList: SampleTakingModel[] = [];
    IntervenionType: EInterventionType;
    ProcessCode: string;
    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'format_list_numbered'
            },
            {
                Id: 1,
                Text: undefined,
                Icon: 'save'
            }
        ];

    // IsMobile: boolean;

    get Total() {
        let total = 0;
        this.SampleTakingList.forEach(x => total += x.Pourcentage);
        return total;
    }

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private coreData: CoreData,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        private iBGNService: IBGNService,
        private mpceService: MPCEService,
        private snackBar: MatSnackBar) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit(): void {
        if (!this.route.snapshot.params.processCode || !this.route.snapshot.params.type) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.IntervenionType = Number(this.route.snapshot.params.type) as EInterventionType;
        this.ProcessCode = this.route.snapshot.params.processCode;
        if (this.IntervenionType === EInterventionType.IBGN) {
            if (this.coreData.IsOffline) {
                this.coreData.getOfflineProcessSubstratList(this.ProcessCode)?.forEach(substrat => {
                    if (substrat.Type) {
                        substrat.Type = substrat.Type;
                    }
                    if (substrat.Pourcentage > 0) {
                        this.SampleTakingList.push(substrat);
                        this.SampleTakingList = _.sortBy(this.SampleTakingList, [function (item) {
                            return item.Type;
                        }]);
                    } else {
                        this.PresenceList.push(substrat);
                        this.PresenceList = _.sortBy(this.PresenceList, [function (item) {
                            return item.Type;
                        }]);
                    }
                });
            } else {
                this.iBGNService.getSubstrat(this.ProcessCode).subscribe(substrat => {
                    substrat.forEach(y => {
                        const s = new SampleTakingModel();
                        s.Pourcentage = y.Pourcentage;
                        s.Type = y.Type;
                        s.PrelevementVitesses = y.PrelevementVitesses;
                        if (s.Pourcentage > 0) {
                            this.SampleTakingList.push(s);
                            this.SampleTakingList = _.sortBy(this.SampleTakingList, [function (item) {
                                return item.Type;
                            }]);
                        } else {
                            this.PresenceList.push(s);
                            this.PresenceList = _.sortBy(this.PresenceList, [function (item) {
                                return item.Type;
                            }]);
                        }
                    });
                });
            }
        } else if (this.IntervenionType === EInterventionType.MPCE) {
            if (this.coreData.IsOffline) {
                this.coreData.getOfflineProcessSubstratList(this.ProcessCode)?.forEach(substrat => {
                    if (substrat.Pourcentage > 0) {
                        if (substrat.Type) {
                            substrat.Type = substrat.Type;
                        }
                        this.SampleTakingList.push(substrat);
                    } else {
                        this.PresenceList.push(substrat);
                        this.PresenceList = _.sortBy(this.PresenceList, [function (item) {
                            return item.Type;
                        }]);
                    }
                });
            } else {
                this.mpceService.getSubstrat(this.ProcessCode).subscribe(x => {
                    x.forEach(y => {
                        const s = new SampleTakingModel();
                        s.Pourcentage = y.Pourcentage;
                        s.Type = y.Type;
                        s.PrelevementVitesses = y.PrelevementVitesses;
                        if (s.Pourcentage > 0) {
                            this.SampleTakingList.push(s);
                            this.SampleTakingList = _.sortBy(this.SampleTakingList, [function (item) {
                                return item.Type;
                            }]);
                        } else {
                            this.PresenceList.push(s);
                            this.PresenceList = _.sortBy(this.PresenceList, [function (item) {
                                return item.Type;
                            }]);
                        }
                    });
                });
            }
        }
    }

    public getTypeOfSubstratName(typeOfSubstrat) {
        if (this.IntervenionType === EInterventionType.IBGN) {
            return StringConverter.getIBGNSubstratName(typeOfSubstrat);
        } else {
            return StringConverter.getMPCESubstratName(typeOfSubstrat);
        }
    }

    public getClasseVitesseName(c: ClasseVitesse) {
        return StringConverter.getClasseVitesseName(c);
    }

    SetSectedSubstrat(s: SampleTakingModel) {
        this.SelectedSubstrat = s;
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                const m: ConfirmBoxModel = new ConfirmBoxModel();
                m.QuestionTitle = 'Etes-vous sur de vouloir regénérer le plan ?';
                const dialogRef = this.dialog.open(ConfirmBoxDialog, {
                    data: m,
                    width: '777px',
                    disableClose: true
                });

                dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
                    if (result) {
                        if (_.sum(this.SampleTakingList.map(x => x.Pourcentage)) !== 100) {
                            NotificationManager.handleWarning('Veuillez ajuster le total à 100%', this.snackBar);
                            return;
                        }
                        if (this.IntervenionType === EInterventionType.IBGN) {
                            this.generateSamplingLocationForIBGN();
                        } else if (this.IntervenionType === EInterventionType.MPCE) {
                            this.generateSamplingLocationForMPCE();
                        }
                    }
                });

                break;
            case 1:
                this.save(false);
                break;
        }
    }

    generateSamplingLocationForIBGN() {
        const FirstLoopList: SampleTakingModel[] = [];
        let isForFirstLoop = true;

        // RESET
        this.SampleTakingList.forEach(x => {
            x.TmpPourcentage = x.Pourcentage;
            x.PrelevementVitesses.forEach(y => y.Prelevements = []);
        });

        this.SampleTakingList.forEach(x => {
            FirstLoopList.push(Object.assign({}, x));
        });
        for (let numeroPot = 1; numeroPot <= 8; numeroPot++) {

            if (isForFirstLoop) { // First loop takes at least one of each substrat ordered by 'habitabilite'

                const s = _.find(this.SampleTakingList, (st) => {
                    return st.Type === _.min(FirstLoopList.map(y => y.Type));
                });
                _.remove(FirstLoopList, s);
                if (!s) {
                    isForFirstLoop = false;
                    numeroPot--;

                    this.SampleTakingList.filter(x => x.TmpPourcentage >= 5).forEach(x => {
                        FirstLoopList.push(Object.assign({}, x));
                    });
                } else {
                    const pv = s.PrelevementVitesses.find(z => z.Representativite === _.max(s.PrelevementVitesses.map(y => y.Representativite)));
                    const p = new Prelevement();
                    p.Numero = numeroPot;
                    pv.Prelevements.push(p);
                }
            } else { // For the other P

                const s = _.find(FirstLoopList, (st) => st.TmpPourcentage === _.max(FirstLoopList.map(y => y.TmpPourcentage)));
                _.remove(FirstLoopList, s);
                const pv = s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).find(b => b.Representativite === _.max(s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).map(n => n.Representativite)));
                const p = new Prelevement();
                p.Numero = numeroPot;
                pv.Prelevements.push(p);

                if (FirstLoopList.length === 0) {
                    this.SampleTakingList.filter(x => x.TmpPourcentage >= 5).forEach(x => {
                        FirstLoopList.push(Object.assign({}, x));
                    });
                }
            }
        }
    }

    generateSamplingLocationForMPCE() {
        this.SampleTakingList.forEach(x => {
            x.TmpPourcentage = x.Pourcentage;
            x.PrelevementVitesses.forEach(y => y.Prelevements = []);
        });

        this.generatePhaseA();
        this.generatePhaseB();
        this.generatePhaseC();
        if (!this.SampleTakingList.find(x => x.Pourcentage < 5)) {
            this.generatePhaseAWithoutSM();
        }
    }

    /** Absence de Substrat Marginaux */
    generatePhaseAWithoutSM() {
        const loopList: SampleTakingModel[] = [];

        // First try to use'substrat dominant' was already picker on phase B and C
        this.SampleTakingList.filter(x => x.PrelevementVitesses.every(y => y.Prelevements.length === 0)).forEach(x => {
            loopList.push(Object.assign({}, x));
        });

        // If all the 'substrat dominant' are already used
        if (loopList.length === 0) {
            this.SampleTakingList.forEach(x => {
                loopList.push(Object.assign({}, x));
            });
        }

        for (let numeroPot = 1; numeroPot <= 4; numeroPot++) {
            const p = new Prelevement();
            p.Numero = numeroPot;

            let s;
            s = _.find(this.SampleTakingList, (st) => {
                return st.Type === _.min(loopList.map(y => y.Type));
            });

            _.remove(loopList, s);

            const pv = s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).find(b => b.Representativite === _.max(s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).map(n => n.Representativite)));
            pv.Prelevements.push(p);

            if (loopList.length === 0) {
                this.SampleTakingList.forEach(x => {
                    loopList.push(Object.assign({}, x));
                });
            }
        }
    }

    generatePhaseA() {
        const loopList: SampleTakingModel[] = [];
        let lastOneByPercentage = false;

        this.SampleTakingList.filter(x => x.TmpPourcentage < 5).forEach(x => {
            loopList.push(Object.assign({}, x));
        });

        if (loopList.length === 0) {
            //   NotificationManager.handleWarning('0 SDm !!!!!!!! Can\'t be TRUE ', this.snackBar);
            return;
        }

        for (let numeroPot = 1; numeroPot <= 4; numeroPot++) {
            const p = new Prelevement();
            p.Numero = numeroPot;

            let s;
            if (!lastOneByPercentage) {
                s = _.find(this.SampleTakingList, (st) => {
                    return st.Type === _.min(loopList.map(y => y.Type));
                });
            } else {
                s = _.find(this.SampleTakingList, (st) => {
                    return st.Pourcentage === _.max(loopList.map(y => y.Pourcentage));
                });
            }
            _.remove(loopList, s);

            const pv = s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).find(b => b.Representativite === _.max(s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).map(n => n.Representativite)));
            pv.Prelevements.push(p);

            if (loopList.length === 0) {
                this.SampleTakingList.filter(x => x.TmpPourcentage < 5).forEach(x => {
                    loopList.push(Object.assign({}, x));
                });
                if (loopList.length as number === 3) {
                    lastOneByPercentage = true;
                }
            }
        }
    }

    generatePhaseB() {
        const loopList: SampleTakingModel[] = [];
        let lastOneByPercentage = false;

        this.SampleTakingList.filter(x => x.TmpPourcentage >= 5).forEach(x => {
            loopList.push(Object.assign({}, x));
        });

        for (let numeroPot = 5; numeroPot <= 8; numeroPot++) {
            const p = new Prelevement();
            p.Numero = numeroPot;

            let s;
            if (!lastOneByPercentage) {
                s = _.find(this.SampleTakingList, (st) => {
                    return st.Type === _.min(loopList.map(y => y.Type));
                });
            } else {
                s = _.find(this.SampleTakingList, (st) => {
                    return st.Pourcentage === _.max(loopList.map(y => y.Pourcentage));
                });
            }
            _.remove(loopList, s);

            const pv: PrelevementVitesse = s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).find(b => b.Representativite === _.max(s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).map(n => n.Representativite)));
            pv.Prelevements.push(p);
            s.TmpPourcentage -= 10;

            if (loopList.length === 0) {

                this.SampleTakingList.filter(x => x.Pourcentage >= 5).forEach(x => {
                    loopList.push(Object.assign({}, x));
                });

                if (loopList.length as number === 3) {
                    lastOneByPercentage = true;
                } else if (loopList.length as number === 2) { // Fucking special case for 2
                    if (!(loopList[0].Pourcentage > 25 || loopList[1].Pourcentage > 25)) {
                        lastOneByPercentage = true;
                    }
                    if (loopList[0].Pourcentage < 25 || loopList[1].Pourcentage < 25) {
                        _.remove(loopList, loopList.find(x => x.Pourcentage === _.min(loopList.map(y => y.Pourcentage))));
                    }
                }
            }
        }
    }

    generatePhaseC() {
        const loopList: SampleTakingModel[] = [];
        let p: Prelevement = new Prelevement();

        this.SampleTakingList.filter(x => x.TmpPourcentage >= 5).forEach(x => {
            loopList.push(Object.assign({}, x));
        });
        for (let numeroPot = 9; numeroPot <= 12; numeroPot++) {

            // Fill missing SDM
            if (loopList.some(x => x.PrelevementVitesses.every(y => y.Prelevements.length === 0))) {

                let missingSDMList: SampleTakingModel[] = [];
                missingSDMList = loopList.filter((x) => x.PrelevementVitesses.every(y => y.Prelevements.length === 0));
                missingSDMList.sort((a, b) => b.TmpPourcentage - a.TmpPourcentage);

                missingSDMList.forEach(mSDM => {
                    p = new Prelevement();
                    if (numeroPot <= 12) {
                        p.Numero = numeroPot;

                        const pvs = mSDM.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(mSDM.PrelevementVitesses.map(z => z.Prelevements.length))).find(b => b.Representativite === _.max(mSDM.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(mSDM.PrelevementVitesses.map(z => z.Prelevements.length))).map(n => n.Representativite)));
                        pvs.Prelevements.push(p);
                        mSDM.TmpPourcentage -= 10;
                        numeroPot++;
                    }
                });
            }

            if (numeroPot > 12) {
                return;
            }
            // Fill the rest by percentage and the -10% rule
            p = new Prelevement();
            p.Numero = numeroPot;

            const s = _.find(loopList, (st) => st.TmpPourcentage === _.max(loopList.map(y => y.TmpPourcentage)));
            const pv = s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length)))
                .find(b => b.Representativite === _.max(s.PrelevementVitesses.filter(x => x.Prelevements.length === _.min(s.PrelevementVitesses.map(z => z.Prelevements.length))).map(n => n.Representativite)));

            s.TmpPourcentage -= 10;
            pv.Prelevements.push(p);
        }
    }

    openSubstratDialog(stm?: SampleTakingModel) {
        const dialogRef = this.dialog.open(SubstratAndVitesseDialogComponent, {
            width: '400px',
            data: {
                stm: stm ? stm : new SampleTakingModel(),
                type: this.IntervenionType,
                alreadyPicked: _.concat(this.SampleTakingList.map(x => x.Type), this.PresenceList.map(x => x.Type))
            }
        });
        dialogRef.afterClosed().subscribe((result: SampleTakingModel) => {
            if (result) {
                if (!stm) { // New Substrat so just added it to the list
                    if (!result.Presence) {
                        this.SampleTakingList.push(result);
                    } else {
                        this.PresenceList.push(result);
                    }
                } else { // Need to update an existing substrat
                    if (!result.Presence) {
                        this.SampleTakingList[this.SampleTakingList.findIndex(x => x.Type === stm.Type)] = result;
                    } else {
                        this.PresenceList[this.PresenceList.findIndex(x => x.Type === stm.Type)] = result;
                    }
                }

                this.SampleTakingList = _.sortBy(this.SampleTakingList, [function (item) {
                    return item.Type;
                }]);
                this.PresenceList = _.sortBy(this.PresenceList, [function (item) {
                    return item.Type;
                }]);
            }
        });
    }

    openPrelevementDialog(p?: Prelevement, pv?: PrelevementVitesse, s?: number) {
        const prelevementDialogModel = new PrelevementDialogModel();
        prelevementDialogModel.Prelevement = p ? p : new Prelevement();
        prelevementDialogModel.PrelevementVitesse = pv ? pv : new PrelevementVitesse();
        prelevementDialogModel.IsCreation = p.Profondeur ? false : true;
        prelevementDialogModel.MainSubstratType = s;
        prelevementDialogModel.InterventionType = this.IntervenionType;

        const dialogRef = this.dialog.open(PrelevementDialogComponent, { width: '400px', data: prelevementDialogModel });
        dialogRef.afterClosed().subscribe((result: Prelevement) => {
            if (result) {
                pv.Prelevements[pv.Prelevements.findIndex(x => x.Numero === p.Numero)] = result;
            }
        });
    }

    deleteSubstrat(s: SampleTakingModel) {
        if (this.IntervenionType === EInterventionType.IBGN) {
            if (this.coreData.IsOffline) {
                if (s.Pourcentage > 0) {
                    _.remove(this.SampleTakingList, x => x.Type === s.Type);
                } else {
                    _.remove(this.PresenceList, x => x.Type === s.Type);
                }
            } else {
                this.iBGNService.deleteSubstrat(this.ProcessCode, s.Type).subscribe(y => {
                    if (s.Pourcentage > 0) {
                        _.remove(this.SampleTakingList, x => x.Type === s.Type);
                    } else {
                        _.remove(this.PresenceList, x => x.Type === s.Type);
                    }
                    NotificationManager.handleSuccess(`Substrat ${StringConverter.getIBGNSubstratName(s.Type)} retiré`, this.snackBar);
                });
            }
        } else if (this.IntervenionType === EInterventionType.MPCE) {
            if (this.coreData.IsOffline) {
                if (s.Pourcentage > 0) {
                    _.remove(this.SampleTakingList, x => x.Type === s.Type);
                } else {
                    _.remove(this.PresenceList, x => x.Type === s.Type);
                }
            } else {
                this.mpceService.deleteSubstrat(this.ProcessCode, s.Type).subscribe(y => {
                    if (s.Pourcentage > 0) {
                        _.remove(this.SampleTakingList, x => x.Type === s.Type);
                    } else {
                        _.remove(this.PresenceList, x => x.Type === s.Type);
                    }
                    NotificationManager.handleSuccess(`Substrat ${StringConverter.getIBGNSubstratName(s.Type)} retiré`, this.snackBar);
                });
            }
        }
    }

    save(forced: boolean) {
        if (_.sum(this.SampleTakingList.map(x => x.Pourcentage)) !== 100 && !forced) {
            NotificationManager.handleWarning('Veuillez ajuster le total à 100%', this.snackBar);
            return;
        }

        if (this.IntervenionType === EInterventionType.IBGN) {
            if (this.coreData.IsOffline) {
                this.coreData.setOfflineProcessSubstratList(this.ProcessCode, [...this.SampleTakingList as any, ...this.PresenceList]);
            } else {
                this.iBGNService.updateSubstratList(this.ProcessCode, [...this.SampleTakingList, ...this.PresenceList]).subscribe(x => x);
            }
        } else if (this.IntervenionType === EInterventionType.MPCE) {

            if (this.coreData.IsOffline) {
                this.coreData.setOfflineProcessSubstratList(this.ProcessCode, [...this.SampleTakingList as any, ...this.PresenceList]);
            } else {
                this.mpceService.updateSubstratList(this.ProcessCode, [...this.SampleTakingList, ...this.PresenceList]).subscribe(x => x);
            }
        }
    }

    // getTypeOfDevice() {
    //   this.IsMobile = window.navigator.userAgent.includes('Mobi');
    //   console.log(this.IsMobile);
    // }
}
